import Pusher from 'pusher-js'

Pusher.logToConsole = import.meta.env.NODE_ENV === 'development'

export const getPusherService = (csrfToken: string): Pusher =>
  new Pusher(import.meta.env.VITE_PUSHER_APP_KEY, {
    cluster: 'eu',
    forceTLS: true,
    authEndpoint: '/api/users/ws/auth/',
    auth: { headers: { 'X-XSRF-Token': csrfToken } },
  })
